// Aviso sonoro de pedido de Rappi (lo usan la bandeja y el aviso global).
let audioCtx = null;

/** Dos pitidos cortos. Sin permiso de audio (el navegador lo bloquea hasta el primer clic) no hace nada. */
export function sonarAvisoRappi() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    audioCtx = audioCtx || new Ctx();
    [0, 0.25].forEach((delay) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0.0001, audioCtx.currentTime + delay);
      gain.gain.exponentialRampToValueAtTime(0.3, audioCtx.currentTime + delay + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + delay + 0.18);
      osc.connect(gain).connect(audioCtx.destination);
      osc.start(audioCtx.currentTime + delay);
      osc.stop(audioCtx.currentTime + delay + 0.2);
    });
  } catch {
    /* sin audio */
  }
}
